var exports = {
  "Sh": "token__Yi9BiP",
  "as": "smallSummary__T4ogtI",
  "T5": "visualLabel__wwswp4",
  "MN": "issueLink__wcdIPM",
};

module.exports = exports;
